import "./CompanyOverviewTabComponent.scss";
import template from "./CompanyOverviewTabComponent.html";
import {IComponentOptions} from "angular";
import {CodeAndExchange, encodeSecurity, securityEquality} from "../../../instruments/types/CodeAndExchange";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {BreakpointObserver} from "../../../services/breakpoints/BreakpointObserver";
import {Breakpoint} from "../../../services/breakpoints/Breakpoint";
// import {formatDate} from "../../../js/util/DateTimeUtil";
// import FileSaver from "file-saver";
// import {ChartIQStockComparisonService} from "../../../components/chartiq/services/comparison/ChartIQStockComparisonService";
// import {ChartIQSerializedLayout} from "../../../components/chartiq/types/ChartIQ";
// import {AddSeriesParams} from "../../../components/chartiq/types/ChartIQEngine";
import {UserInterfaceConfigurationService} from "../../../services/configuration/UserInterfaceConfigurationService";
// import {isNotNull} from "../../../js/util/UtilFunctions";
// import {Pair, PairOf} from "../../../types/GenericTypes";

export const CompanyOverview = "tfCompanyOverviewTab";

export function companyOverview(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<"
        },
        controllerAs: "ctrl",
        controller: CompanyOverviewTabComponentController
    };
}

export class CompanyOverviewTabComponentController {

    /** @input */
    public set security(security: CodeAndExchange | null) {
        if (security != null) {
            this.security$.next(security);
        }
    }

    public readonly security$ = new ReplaySubject<CodeAndExchange>(1);

    public readonly chartCode$: Observable<string>;
    public readonly chartSymbol$: Observable<string>;
    public readonly showChart$: Observable<boolean>;

    private readonly capture$ = new Subject<boolean>();
    private readonly addComparison$ = new Subject<boolean>();
    private readonly toggleHud$ = new Subject<boolean>();

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver,
                       // private readonly iqStockComparisonService: ChartIQStockComparisonService,
                       private readonly userInterfaceConfigurationService: UserInterfaceConfigurationService) {
        this.chartCode$ = this.buildChartCode();
        this.showChart$ = this.buildShowChart();
        this.chartSymbol$ = this.buildChartSymbol();
        // this.watchCapture();
        // this.watchAddComparison();
        // this.watchToggleHud();
        // this.watchConfigChanges();
        this.watchConfigSources();
        // this.config = this.buildConfig();
    }

    private buildChartCode(): Observable<string> {
        return this.security$
                   .map((s) => s.code)
                   .distinctUntilChanged()
                   .publishReplay(1)
                   .refCount();
    }

    private buildChartSymbol(): Observable<string> {
        return this.security$
                   .map((s) => `${s.code}:${s.exchange}`)
                   .distinctUntilChanged()
                   .publishReplay(1)
                   .refCount();
    }

    private buildShowChart(): Observable<boolean> {
        const smallActive$ = this.breakpointObserver
                                 .observe(Breakpoint.SM)
                                 .map((bp) => bp.active);
        const extraSmallActive$ = this.breakpointObserver
                                      .observe(Breakpoint.XS)
                                      .map((bp) => bp.active);
        return Observable.combineLatest(smallActive$, extraSmallActive$)
                         .map(([s, xs]) => !(s || xs))
                         .publishReplay(1)
                         .refCount();
    }

    /* This is pretty gross code but is the only way I can think of doing it right now */
    private watchConfigSources() {
        // this.security$
        //     .distinctUntilChanged(securityEquality())
        //     .map(UiConfigKey)
        //     .switchMap((key) => this.chartApi$.first().switchMap((api) => this.retrieveConfig(key, api)))
        //     .subscribe(([api, config]) => {
        //         if (config.layout != null) {
        //             api.importLayout(config.layout);
        //         }
        //         if (config.drawings != null) {
        //             api.importDrawings(config.drawings);
        //         }
        //         if (config.series != null) {
        //             api.replaceSeries(config.series);
        //         }
        //     });
    }

    // private retrieveConfig(key: string, api: ChartApi): Observable<Pair<ChartApi, ChartConfiguration>> {
    //     const response = this.userInterfaceConfigurationService.load<ChartConfiguration>(key);
    //     return Observable.fromPromise(response)
    //                      .filter(isNotNull)
    //                      .map((config) => PairOf(api, config))
    //                      .catch(() => Observable.empty());
    // }
    //
    // private watchCapture() {
    //     this.capture$
    //         .withLatestFrom(this.chartApi$, this.security$)
    //         .subscribe(async ([_, api, security]) => {
    //             const blob = await api.capture();
    //             const date = formatDate(Date.now(), "YYYYMMDDHHmmss");
    //             const filename = `${security.code}-${date}.png`;
    //             FileSaver.saveAs(blob, filename);
    //         });
    // }
    //
    // private watchAddComparison() {
    //     this.addComparison$
    //         .withLatestFrom(this.chartApi$)
    //         .subscribe(async ([_, api]) => {
    //             const current = api.currentSeries();
    //             const comparisons = await this.iqStockComparisonService.open(current);
    //             api.replaceSeries(comparisons);
    //         });
    // }
    //
    // private watchToggleHud() {
    //     this.toggleHud$
    //         .withLatestFrom(this.chartApi$)
    //         .subscribe(([_, api]) => api.toggleHud());
    // }
    //
    // private watchConfigChanges() {
    //     this.security$
    //         .distinctUntilChanged(securityEquality())
    //         .switchMap(() => this.chartApi$)
    //         .switchMap((api) => {
    //             return Observable.merge(api.seriesChanges, api.drawingChanges, api.layoutChanges).map(() => api);
    //         })
    //         .auditTime(1000)
    //         .withLatestFrom(this.security$)
    //         .subscribe(([api, security]) => {
    //             console.log("Saving config for ", security);
    //             const layout = api.exportLayout(false);
    //             const drawings = api.exportDrawings();
    //             const series = api.currentSeries();
    //
    //             const key = UiConfigKey(security);
    //
    //             const config: ChartConfiguration = {layout, drawings, series};
    //             this.userInterfaceConfigurationService.save(key, config);
    //         });
    // }
    //
    // public chartInitialized(api: ChartApi) {
    //     this.chartApi$.next(api);
    // }

    public capture() {
        this.capture$.next(true);
    }

    public addComparison() {
        this.addComparison$.next(true);
    }

    public toggleHud() {
        this.toggleHud$.next(true);
    }
}

function UiConfigKey(security: CodeAndExchange): string {
    return `CompanyOverviewChart-${encodeSecurity(security)}`;
}

interface ChartConfiguration {
    // readonly layout: ChartIQSerializedLayout | null;
    readonly drawings: any | null;
    // readonly series: Array<AddSeriesParams> | null;
}
